export enum AppContentType {
    PAIN = "PAIN",
    BEHAVIORAL_HEALTH = "BEHAVIORAL_HEALTH",
}